export enum CoreAction {
  AssociatedApplications = 'associated-applications',
  PVWattsLossCalculator = 'loss-calculator'
}
